import {viewshed} from "../utils/viewshed";
import {initSmsD3Listener, initTchapListener} from "../utils/event-detail";

import {STORAGE_KEYS, Storage} from "../utils/store";

/**
 * Extension de la popup, pour charger le 
 * template en fonction du type de l'overlay 
 */
const overlayPopup = L.Popup.extend({
    initialize: function(properties, options) {
        L.Popup.prototype.initialize.call(this, options);

        const type = properties.type?.name ?? properties.type ?? 'default';
        let templateName = properties.operateur ? 'operateur-popup' : `${type}-popup`;

        if (!(templateName in Handlebars.templates)) {
            templateName = 'default-popup';
        }

        if (templateName.startsWith('default') && options?.editable) {
            templateName = `editable-${templateName}`;
        }

        if ('callbacks' in (options ?? {})) {
            window.popupCallback = options.callbacks;
        }

        const latlng = options?.latlng || options?.latLng || null;
        const user = Storage.get(STORAGE_KEYS.USER_DETAILS);
        const isEventMap = options?.map instanceof L.eventMap 
            || (options?.map?._container?.id === 'map' && window.location.href.includes('event='))
            || window.location.href.includes('event=');
        const hasCoordinates = !!latlng;

        this.setContent(Handlebars.templates[templateName]({
            properties,
            options,
            latlng,
            hasCoordinates,
            user,
            isEventMap,
            isEventDetails: isEventMap,
            featureId: options?.featureId ?? properties?.id ?? null
        }));

        this.on('add', () => {
            initSmsD3Listener();
            initTchapListener();
        });
    },
});

window.viewshed = viewshed;

(() => {
    L.overlayPopup = (properties, options) => new overlayPopup(properties, options);
})();
